<template>
  <modal @close="$emit('close')">
    <div class="w-full mb-4" v-if="existing.image">
      <label class="w-full cursor-pointer text-sm pl-1 text-blue-8">Current Image:</label>
      <img :src="existing.image.full" class="w-full h-auto" />
    </div>
    <div class="w-full mb-4" v-if="existing.image">
      <nx-button type="danger" native-type="button" @click="remove">Remove Image</nx-button>
    </div>
    <form class="w-full mb-4" @submit.prevent="submit">
      <div class="w-full mb-2">
        <nx-file-input
          :errors="form.errors"
          :label="existing.image ? 'Replace Image' : 'Image'"
          id="file"
          accept="image/*"
          @input="input"
          info="Images must be at least 1200px wide and 400px tall."
        ></nx-file-input>
      </div>

      <nx-button
        native-type="submit"
        v-if="file"
        type="secondary"
        :disabled="loading"
      >{{ loading ? 'Loading..' : 'Upload Image' }}</nx-button>
    </form>
  </modal>
</template>

<script>
import Form from "form-backend-validation"
export default {
  name: "ChannelImageForm",
  props: {
    existing: {
      required: true
    },
    category: {
      required: true
    }
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      file: null
    }
  },
  methods: {
    input(file) {
      this.file = file
      this.form.errors.clear("file")
    },
    async submit() {
      this.loading = true
      await this.$api.channels
        .image(this.category.slug, this.existing.slug, this.file)
        .then(() => {
          this.$toasted.success("Channel image updated.")
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
        })
      this.loading = false
    },
    async remove() {
      this.loading = true
      await this.$api.channels
        .imageDestroy(this.category.slug, this.existing.slug, null)
        .then(() => {
          this.$toasted.success("Channel image removed.")
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
        })
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
